import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Grid from "@mui/material/Grid";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import {
  useAnswerTicketMutation,
  useDeleteTicketMutation,
  useEditTicketMessageMutation,
  useTicketDetailsQuery,
  useTicketListQuery,
} from "api/ticket/ticket.mutation";
import Attachment from "assets/admin/attachment.svg";
import ChatIcon from "assets/admin/comment-dots.svg";
import profileIcon from "assets/admin/profile.svg";
import Send from "assets/admin/send.svg";
import { TAB_OPTIONS } from "constants/tabs";
import { handleError } from "functions/apiHandleError";
import { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { ChatItem } from "./components/chatItem";
import Message from "./components/message";
import { SkeletonProvider } from "./components/skelton";
import classes from "./style.module.scss";

const ChatTicket = () => {
  const scrollRef = useRef(null);

  const [tabValue, setTabValue] = useState("new");
  const [ticketSummery, setTicketSummary] = useState(null);
  const [inputValues, setInputValues] = useState({
    message: "",
  });
  const [messageFile, setMessageFile] = useState(null);
  const [messageFilePreviewUrl, setMessageFilePreviewUrl] = useState(null);
  const ticketListParams =
    tabValue === "new"
      ? { myTicket: false, status: "Waiting_For_An_Answer" }
      : tabValue === "mine"
      ? { myTicket: true, status: "Waiting_For_An_Answer,Has_Been_Answered" }
      : { myTicket: true, status: "Closed" };
  const ticketListQuery = useTicketListQuery(ticketListParams);
  const ticketDetailsQuery = useTicketDetailsQuery(ticketSummery?.id);
  const answerTicketMutation = useAnswerTicketMutation();
  const editTicketMessageMutation = useEditTicketMessageMutation();
  const deleteTicketMutation = useDeleteTicketMutation();
  const ticketList = ticketListQuery.data?.results;
  const ticketDetails = ticketDetailsQuery.data;
  const tabValueHandleChange = (_, newValue) => {
    setTabValue(newValue);
    setTicketSummary(null);
  };
  const uploadFileHandler = (e) => {
    setMessageFile(e.target.files[0]);
  };
  const onCloseTicketHandler = async () => {
    try {
      await deleteTicketMutation.mutateAsync(ticketSummery.id);
      setTicketSummary(null);
      setTabValue("closed");
    } catch (err) {
      handleError({ err });
    }
  };
  const handleChatItemChoosed = async (item) => {
    setTicketSummary(item);
  };
  const fetchFileFromURL = async (url, filename) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const contentType = response.headers.get("Content-Type") || blob.type;

    const file = new File([blob], filename, {
      type: contentType,
      lastModified: new Date().getTime(),
    });

    return file;
  };
  const handleSetEditMessage = async (messageID, message, fileUrl) => {
    setInputValues({
      message: message,
      messageID: messageID,
    });
    if (fileUrl) {
      const fileName = fileUrl.split("/").pop() || "attachment";

      try {
        const file = await fetchFileFromURL(fileUrl, fileName);
        setMessageFile(file);
      } catch (error) {
        setMessageFile(null);
      }
    } else {
      setMessageFile(null);
    }
  };
  const onSendHandler = async () => {
    try {
      const formData = new FormData();

      formData.delete("message");
      formData.delete("chatroom_id");
      formData.append("message", inputValues.message);
      if (messageFile) {
        formData.append("file", messageFile);
      }
      formData.append("chatroom_id", ticketDetails.id);
      if (inputValues?.messageID) {
        formData.delete("chatroom_id");
        await editTicketMessageMutation.mutateAsync({
          messageID: inputValues?.messageID,
          data: formData,
        });
        setInputValues({
          message: "",
          messageID: null,
        });
        setMessageFile(null);
      } else {
        await answerTicketMutation.mutateAsync(formData);
        setInputValues({
          message: "",
        });
      }
    } catch (err) {
      handleError({ err });
    }
  };

  useEffect(() => {
    if (ticketDetails && scrollRef.current) {
      const timeoutId = window.setTimeout(() => {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }, 300);

      return () => window.clearTimeout(timeoutId);
    }
  }, [ticketDetails]);

  useEffect(() => {
    if (!messageFile) {
      setMessageFilePreviewUrl(null);
      return undefined;
    }

    const previewUrl = URL.createObjectURL(messageFile);
    setMessageFilePreviewUrl(previewUrl);

    return () => URL.revokeObjectURL(previewUrl);
  }, [messageFile]);

  return (
    <>
      <div className={classes.mainDiv}>
        <Grid container spacing={3} direction="row">
          <Grid item xs={12} md={4} lg={3}>
            <div className={classes.box}>
              <TabContext value={tabValue}>
                <div className={classes.boxHeader}>
                  <TabList
                    variant="fullWidth"
                    onChange={tabValueHandleChange}
                    className={classes.tabsList}
                  >
                    {TAB_OPTIONS?.map((item, index) => (
                      <Tab key={index} label={item.label} value={item.value} />
                    ))}
                  </TabList>
                </div>
                {TAB_OPTIONS?.map((item, index) => (
                  <TabPanel key={index} value={item.value} className={classes.chat_contact_field}>
                    {ticketList ? (
                      ticketList?.map((ticketItem, ticketIndex) => (
                        <ChatItem
                          key={ticketIndex}
                          item={ticketItem}
                          onClick={() => handleChatItemChoosed(ticketItem)}
                        />
                      ))
                    ) : (
                      <SkeletonProvider />
                    )}
                  </TabPanel>
                ))}
              </TabContext>
            </div>
          </Grid>
          <Grid item xs={12} md={8} lg={9}>
            <div className={classes.chatBox}>
              <div className={classes.chatBoxHeader}>
                <div className={classes.chatProfileItem}>
                  <LazyLoadImage src={profileIcon} className={classes.chatProfileImage} />
                  <div className={classes.chatProfileInfo}>
                    <Typography className={classes.chatProfileName}>
                      {ticketDetails?.title}
                    </Typography>
                  </div>
                </div>
                {ticketDetails?.can_close && tabValue !== "closed" && (
                  <div className={classes.close_ticket} onClick={onCloseTicketHandler}>
                    بستن تیکت
                  </div>
                )}
              </div>
              <div className={classes.chatBoxMessage}>
                {!ticketDetails && (
                  <div className={classes.empty_field}>
                    <LazyLoadImage className={classes.chatIcon} src={ChatIcon} alt="" />
                    ابتدا چت مورد نظر را انتخاب کنید !
                  </div>
                )}
                <div className={classes.chatBoxMessageTool} ref={scrollRef}>
                  {ticketDetails?.messages?.map((item, index) => (
                    <Message
                      key={index}
                      isUserOwner={item?.user_owner}
                      message={item?.message}
                      fileURL={item?.file_url}
                      createdTime={item?.created_at}
                      onEdit={(message, fileUrl) => handleSetEditMessage(item.id, message, fileUrl)}
                    />
                  ))}
                </div>
                {tabValue !== "closed" && ticketDetails && (
                  <>
                    <div className={classes.send_message_container}>
                      <div className={classes.send_container}>
                        <div className={classes.send_arrow} onClick={onSendHandler}>
                          <LazyLoadImage className={classes.arrowIcon} src={Send} alt="send-icon" />
                        </div>
                        <div className={classes.attach}>
                          <input
                            type="file"
                            id="attachment"
                            name="attachment"
                            hidden
                            onChange={uploadFileHandler}
                          />
                          <label htmlFor="attachment">
                            <LazyLoadImage
                              className={classes.attachmentIcon}
                              src={Attachment}
                              alt=""
                            />
                          </label>
                        </div>
                      </div>
                      <textarea
                        placeholder="پیام خود را وارد کنید !"
                        value={inputValues.message}
                        onChange={(e) => {
                          setInputValues({
                            ...inputValues,
                            message: e.target.value,
                          });
                        }}
                      />
                    </div>
                    {messageFile && (
                      <div className={classes.messageUploadedFile}>
                        <a
                          className={`${classes.messageFile}`}
                          href={messageFilePreviewUrl}
                          download
                          target="_blank"
                          rel="noreferrer"
                        >
                          پیش نمایش پیوست
                        </a>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default ChatTicket;
